const organizationActionConstants = {
  GET_ORGANIZATIONS: 'GET_ORGANIZATIONS',
  GET_ORGANIZATIONS_SUCCESS: 'GET_ORGANIZATIONS_SUCCESS',
  GET_ORGANIZATIONS_ERROR: 'GET_ORGANIZATIONS_ERROR',

  SET_CURRENT_ORGANIZATION: 'SET_CURRENT_ORGANIZATION',

  GET_ORGANIZATION_BY_IDENTIFIER: 'GET_ORGANIZATION_BY_IDENTIFIER',
  GET_ORGANIZATION_BY_IDENTIFIER_SUCCESS: 'GET_ORGANIZATION_BY_IDENTIFIER_SUCCESS',
  GET_ORGANIZATION_BY_IDENTIFIER_ERROR: 'GET_ORGANIZATION_BY_IDENTIFIER_ERROR',

  SET_CURRENT_ORGANIZATION_LOADING: 'SET_CURRENT_ORGANIZATION_LOADING',
  REMOVE_CURRENT_ORGANIZATION: 'REMOVE_CURRENT_ORGANIZATION',
  SET_ORGANIZATION_FETCHED: 'SET_ORGANIZATION_FETCHED',
  GET_DROPDOWN_VALUES: 'GET_DROPDOWN_VALUES',
  GET_DROPDOWN_VALUES_SUCCESS: 'GET_DROPDOWN_VALUES_SUCCESS',
  GET_DROPDOWN_VALUES_ERROR: 'GET_DROPDOWN_VALUES_ERROR',
  SAVE_ORGANIZATION_DETAILS: 'SAVE_ORGANIZATION_DETAILS',
  SAVE_ORGANIZATION_DETAILS_SUCCESS: 'SAVE_ORGANIZATION_DETAILS_SUCCESS',
  SAVE_ORGANIZATION_DETAILS_ERROR: 'SAVE_ORGANIZATION_DETAILS_ERROR',
};

export default organizationActionConstants;
